import React from 'react';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import './team-section.scss';

type TeamSectionProps = {
  title: string;
  children?: React.ReactNode;
};

export function TeamSection(props: TeamSectionProps): JSX.Element {
  const { title, children } = props;
  return (
    <Flex className="team-section" direction="column" gap="md" alignment="center">
      <div className="team-section-header">
        <Typography className="team-section-badge" variant="header">
          {title}
        </Typography>
      </div>
      <Flex className="team-section-content" direction="row" gap="lg" alignment="center">
        {children}
      </Flex>
    </Flex>
  );
}
